import request from '@/utils/request';

export function getAudioCommentList(params, silentRequest = false) {
  return request({
    url: '/AudioReview/getExplore',
    params,
    silentRequest,
  });
}

export function createAudioComment(data) {
  return request({
    url: '/AudioReview/create',
    method: 'POST',
    data,
  });
}

export function getWorkCommentList(params, silentRequest = false) {
  return request({
    url: '/WorkReview/getExplore',
    params,
    silentRequest,
  });
}

export function createWorkComment(data) {
  return request({
    url: '/WorkReview/create',
    method: 'POST',
    data,
  });
}
